import { render, staticRenderFns } from "./YaprakPage.vue?vue&type=template&id=edfab7e2&scoped=true&"
import script from "./YaprakPage.vue?vue&type=script&lang=js&"
export * from "./YaprakPage.vue?vue&type=script&lang=js&"
import style0 from "./YaprakPage.vue?vue&type=style&index=0&id=edfab7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfab7e2",
  null
  
)

export default component.exports